/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React from 'react'
import { Link } from 'react-router-dom'
import { getEncryptedRoute, limitLength } from '../../../../reusable'
import {KTIcon} from '../../../helpers'
import { Tr } from '../../../i18n/Tr'

type Props = {
  className: string
  color: string
  rentablespaceId:string
  rentableSpaceName: string
  image: string
  description: string
  maxPeople:string
  progress: string
  deleteRentableSpace?:any
  editModalOpen?:any
  showEdit?:any
  showDelete?:any
  menuId:any

}

const MixedWidget22: React.FC<Props> = ({className, color, rentablespaceId, rentableSpaceName, image, description, maxPeople, progress, deleteRentableSpace,editModalOpen , showDelete , showEdit , menuId}) => {
  let t = Tr()
  return (
    <div className={`card ${className}`}>
      {/* begin::Body */}
      <div className='card-body'>
        {/* begin::Heading */}
        <div className='d-flex flex-stack'>
          {/* begin:Info */}
          <div className='d-flex align-items-center'>
            {/* begin:Image */}
            <div className='symbol symbol-60px me-5'>
              <span className={clsx(`symbol-label`, `bg-${color}-light`)}>
                <img src={image} className='h-55px w-100 rounded align-self-center' alt='' />
              </span>
            </div>
            {/* end:Image */}

            {/* begin:Title */}
            <div className='d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3'>
              
              <Link 
              to={getEncryptedRoute('../rentablespaceoverview/',{menuId : menuId})  } 
              state={{rentablespaceId:rentablespaceId}} className='text-dark fw-bold text-hover-primary fs-5'>
                {limitLength(rentableSpaceName,22)}
              </Link>

            </div>
            {/* end:Title */}
          </div>
          {/* begin:Info */}

          {/* begin:Menu */}
          <div className='ms-1'>
            {
              editModalOpen && (
                <>
               {showEdit ?  <button
                  onClick={()=>editModalOpen(rentablespaceId)}
                  className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                  data-kt-menu-trigger='click'
                  data-kt-menu-placement='bottom-end'
                  data-kt-menu-flip='top-end'
                >
                  <KTIcon iconName='notepad-edit' className='fs-2' />
                </button> :""}
                </>
              )
            }
         {showDelete?   <button
              onClick={()=>deleteRentableSpace(rentablespaceId)}
              className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <KTIcon iconName='trash-square' className='fs-2' />
            </button> :""}
          </div>
          {/* end::Menu */}
        </div>
        {/* end::Heading */}

        {/* begin:Stats */}
        <div className='d-flex flex-column w-100 mt-12'>

          <div className='progress h-5px w-100'>
            <div
              className={`progress-bar bg-${color}`}
              role='progressbar'
              style={{width: progress}}
            ></div>
          </div>
        </div>
        {/* end:Stats */}

        {/* begin:Team */}
        <div className='d-flex flex-column mt-10'>
          <div className='text-dark me-2 fw-bold pb-0'>{t("Capacity")}</div>
          <span className='text-muted fw-semibold mb-5'>{maxPeople} {t("Peoples")}</span>
          <div className='text-dark me-2 fw-bold pb-1'>{t("Description")}</div>
          <span className='text-muted fw-semibold'>{limitLength(description,110)}</span>
          
        </div>
        {/* end:Team */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {MixedWidget22}
